import React from 'react'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import { InsertionFlowScreensProps } from '../../../../../../../@types/props-types'
import { FieldProps } from '../../../../../../../@types/types'
import Costs from '../../Costs'
import PriceField, { PriceFieldType } from '../../../basicInfo/fields/priceField/PriceField'
import { IconS24EuroCircle24 } from '@is24/cosma-ui-icons'
import { purchasePriceOnRequestToggle } from '../../../basicInfo/wrappers/basicInfoFieldsWrapper'
import { rentalIncome, rentSubsidy } from '../../../otherFacilities/wrapper/otherFacilitiesFieldsWrapper'

const WebViewCostsSell: React.FC<InsertionFlowScreensProps<CostsScreenValidationResult>> = (props) => {
  return (
    <Costs {...props} headerKey='wizard.screen.costs.mobileNativeHeader' headerIcon={<IconS24EuroCircle24 />}>
      {(costsWrapperProps: FieldProps<CostsScreenValidationResult>) => (
        <div className='grid grid-flex gutter-vertical-l'>
          <div className='grid-item one-whole'>
            <PriceField
              {...costsWrapperProps}
              priceFieldType={PriceFieldType.BUY_PRICE}
              showLabelWithTooltip={true}
              tooltipTranslationKey={'wizard.screen.costs.purchasePriceFactorsHint'}
              wrapperClassName='grid-item one-whole'
            />
            <div className='grid-item one-whole margin-top-l'>
              {purchasePriceOnRequestToggle(undefined, 'maxSpread')(costsWrapperProps)}
            </div>
            <div className='grid-item one-whole margin-top-l'>
              {rentSubsidy('grid-item one-whole', false)(costsWrapperProps)}
            </div>
            <div className='grid-item one-whole margin-top-l'>
              {rentalIncome(undefined, 'maxSpread')(costsWrapperProps)}
            </div>
          </div>
        </div>
      )}
    </Costs>
  )
}

export default WebViewCostsSell
